import { useStore, create } from "zustand";

import { AmpolService } from "./types";

interface SelectionStore {
  selection: AmpolService["$id"] | null;
  setSelection: (id: AmpolService["$id"] | null) => void;
}

const selectionStore = create<SelectionStore>()((set, get) => ({
  selection: null,
  setSelection: (id) => set({ selection: id }),
}));

function useSelectionStore(): SelectionStore;
function useSelectionStore<T>(
  selector: (state: SelectionStore) => T,
  equals?: (a: T, b: T) => boolean
): T;
function useSelectionStore<T>(
  selector?: (state: SelectionStore) => T,
  equals?: (a: T, b: T) => boolean
) {
  return useStore(selectionStore, selector!, equals);
}

export default useSelectionStore;
